import styled from 'styled-components';
import { IFrame } from './interface';

const templateAreaForGlobalActive = `
  'tedsReceived tedsSent'
  'faresReceived income'
  'lastTwelveMonths table'
`;

const templateAreaForGlobalActiveNotebook = `
  'tedsReceived tedsSent'
  'faresReceived income'
  'table table'
  'lastTwelveMonths .'
`;

const templateAreaForGlobalInactive = `
  'tedsReceived tedsReceived tedsReceived tedsSent tedsSent tedsSent'
  'faresReceived faresReceived faresPassedOn faresPassedOn income income'
  'lastTwelveMonths lastTwelveMonths lastTwelveMonths table table table'
`;

const base = styled.div<IFrame>`
  display: ${(props) => (props.isActive === true ? 'grid' : 'none')};
  grid-template-columns: ${(props) =>
    props.globalIsActive ? 'repeat(2, 1fr)' : 'repeat(6, 1fr)'};
  grid-template-rows: ${(props) =>
    props.globalIsActive ? 'repeat(4, 1fr)' : 'repeat(3, 1fr)'};
  grid-template-areas: ${(props) =>
    props.globalIsActive
      ? templateAreaForGlobalActiveNotebook
      : templateAreaForGlobalInactive};
  column-gap: 1rem;
  row-gap: 1rem;
  width: 100%;
  margin-top: 0.5rem;

  @media (min-width: ${(props) => props.theme.mediaQuery.desktop}) {
    grid-template-columns: ${(props) =>
      props.globalIsActive ? 'repeat(2, 1fr)' : 'repeat(6, 1fr)'};
    grid-template-areas: ${(props) =>
      props.globalIsActive
        ? templateAreaForGlobalActive
        : templateAreaForGlobalInactive};
  }
`;

const Frame = {
  Base: base,
};

export default Frame;
